// Assigned onto window deliberately: inline scripts in the ERB views reference it as a global.
window.LinkAction = require('../javascripts/link-action.js');